'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getData = getData;
exports.postData = postData;
exports.putData = putData;
exports.deleteData = deleteData;
function setFetch() {
    require('es6-promise').polyfill();
    require('isomorphic-fetch');
}

function createFetchParameters(header, body, method) {
    var obj = {};

    if (header) {
        obj.headers = header;
    }
    if (body) {
        obj.body = JSON.stringify(body);
    }

    obj.method = method;

    return obj;
}

function rejectRequest(response) {
    return response.json().then(function (errBody) {
        var error = { status: response.status, body: errBody };
        throw error;
    }).catch(function () {
        throw response;
    });
}

function getData(url, header, body) {
    var fetchURL = url;
    var fetchParameters = createFetchParameters(header, body, 'GET');

    if (typeof fetch === 'undefined') {
        setFetch();
    }
    return fetch(fetchURL, fetchParameters).then(function (response) {
        if (response.ok) {
            return response.json();
        }
        return rejectRequest(response);
    });
}

function postData(url, header, body, acceptStatus) {
    var fetchURL = url;
    var fetchParameters = createFetchParameters(header, body, 'POST');

    if (typeof fetch === 'undefined') {
        setFetch();
    }
    return fetch(fetchURL, fetchParameters).then(function (response) {
        if (response.ok || acceptStatus && response.status === acceptStatus) {
            return response.json();
        }
        return rejectRequest(response);
    });
}

function putData(url, header, body) {
    var fetchURL = url;
    var fetchParameters = createFetchParameters(header, body, 'PUT');

    if (typeof fetch === 'undefined') {
        setFetch();
    }
    return fetch(fetchURL, fetchParameters).then(function (response) {
        if (response.status === 200) {
            return response.json();
        } else if (response.status === 204) {
            return response;
        }
        return rejectRequest(response);
    });
}

function deleteData(url, header, body) {
    var fetchURL = url;
    var fetchParameters = createFetchParameters(header, body, 'DELETE');

    if (typeof fetch === 'undefined') {
        setFetch();
    }
    return fetch(fetchURL, fetchParameters).then(function (response) {
        if (response.ok) {
            return response;
        }
        return rejectRequest(response);
    });
}


//////////////////
// WEBPACK FOOTER
// ./~/@getgo/webinar.com-frontend-redux/lib/helpers/httpService.js
// module id = 749
// module chunks = 0